import { List, Datagrid, TextField } from "react-admin";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import { ListPagination, downloadCsv } from "../../../utils";

const exporterTypeUser = (data) => {
  const dataForExport = data.map((item) => ({
    ID: item.id,
    Tipo: item.type,
  }));

  const csv = convertToCSV(
    { data: dataForExport, fields: ["ID", "Tipo"] },
    { delimiter: ";" }
  );

  downloadCsv(csv, "type-user");
};

const TypeUserList = (props) => (
  <List
    exporter={exporterTypeUser}
    perPage={25}
    title="Lista de Tipos de Usuário"
    sort={{ field: "createdAt", order: "DESC" }}
    pagination={<ListPagination />}
    {...props}
  >
    <Datagrid rowClick="edit">
      <TextField label="ID" source="id" />
      <TextField sortable={false} label="Tipo" source="type" />
    </Datagrid>
  </List>
);

export default TypeUserList;
